import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzIconModule} from 'ng-zorro-antd/icon';

import {DiEntityActionMenuComponent} from 'app/common/di-entity-action-menu/di-entity-action-menu.component';
import {NzDropdownModule} from 'ng-zorro-antd/dropdown';

@NgModule({
    declarations: [DiEntityActionMenuComponent],
    imports: [CommonModule, TranslateModule, NzIconModule, NzButtonModule, NzDropdownModule],
    exports: [DiEntityActionMenuComponent],
    providers: []
})
export class DiEntityActionMenuModule {}
